import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Configuration } from '../../../app.constants';

@Component({
  selector: 'app-duplicate-associate',
  templateUrl: './duplicate-associate.component.html',
  styleUrls: ['./duplicate-associate.component.scss']
})
export class DuplicateAssociateComponent implements OnInit {
  public associate;
  public serverApiUrl;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<DuplicateAssociateComponent>,
  public config: Configuration) { }

  ngOnInit() {
    this.serverApiUrl = this.config.StaticImageUrl;
    if (this.data != null ) {
      this.associate = this.data.associate;
    }
  }

  cancel() {
    this.dialogRef.close('Cancel');
  }
  proceed() {
    this.dialogRef.close('Proceed');
  }

}
